import kraken from './colors/kraken-color'
import port from './colors/port-color'
import explore from './colors/explore-color'
import plan from './colors/plan-color'
import predict from './colors/predict-color'
import security from './colors/security-color'
import terminal from './colors/terminal-color'
import traffic from './colors/traffic-color'
import info from './colors/info-color'
import success from './colors/success-color'
import warning from './colors/warn-color'
import error from './colors/error-color'
import grey from './colors/grey-color'
import linkColor from './colors/link-color'
import { ThemeOptions } from '@mui/material/styles'
import sharedThemeOptions from '../sharedThemeOptions'

const createLightThemeOptions = (): ThemeOptions => {
  // Shared options
  const { components, ...topLevel } = sharedThemeOptions('light', kraken.main, linkColor.main)

  // Light options
  return {
    ...topLevel,
    palette: {
      mode: 'light',
      primary: kraken,
      secondary: kraken,
      info,
      success,
      warning,
      error,
      action: {
        active: 'rgba(0, 0, 0, 0.54)',
        hover: 'rgba(0, 0, 0, 0.04)',
        selected: 'rgba(0, 0, 0, 0.08)',
        disabled: 'rgba(0, 0, 0, 0.26)',
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
      },
      text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.54)',
        disabled: 'rgba(0, 0, 0, 0.38)',
      },
      background: {
        default: '#fafafa',
        paper: '#fff',
      },
      divider: 'rgba(0, 0, 0, 0.12)',
      grey,
    },
    components: {
      ...components,
      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundColor: '#fff',
            color: 'rgba(0, 0, 0, 0.87)',
          },
          colorPrimary: {
            backgroundColor: '#fff',
            color: 'rgba(0, 0, 0, 0.87)',
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          elevation0: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation1: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation2: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation3: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation4: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation5: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation6: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation7: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation8: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation9: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation10: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation11: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation12: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation13: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation14: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation15: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation16: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation17: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation18: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation19: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation20: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation21: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation22: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation23: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
          elevation24: {
            backgroundColor: '#fff',
            // backgroundImage: 'none',
          },
        },
      },
      MuiAlert: {
        styleOverrides: {
          root: {
            alignItems: 'center',
          },
          action: {
            paddingTop: 0,
            'button:hover': {
              borderColor: 'inherit',
              backgroundColor: 'inherit',
            },
          },
          filled: {
            color: '#FFFFFFDE',
            backgroundColor: '#293036',
          },
          filledInfo: {
            color: '#FFFFFFDE',
            backgroundColor: '#22AAFF',
          },
          filledError: {
            color: '#FFFFFFDE',
            backgroundColor: '#FF5722',
          },
          filledSuccess: {
            color: '#FFFFFFDE',
            backgroundColor: '#66BB6A',
          },
          filledWarning: {
            color: '#000000DE',
            backgroundColor: '#FFC107',
          },
        },
      },
    },
    kraken: {
      tools: {
        explore,
        kraken,
        plan,
        port,
        predict,
        security,
        terminal,
        traffic,
      },
    },
  }
}

const lightThemeOptions = createLightThemeOptions()
export default lightThemeOptions
